import _extends from "@babel/runtime-corejs3/helpers/extends";import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";import React from 'react';
import Dropdown from "../../Dropdown";


import { PeopleOutline, AccountCircle, ExitToApp, AssignmentInd } from "../../../icons";
import { adminRights, eeRights, userAccessRights } from "../../../utils/accessRights";
import { HeaderLinksRoutes } from "../index";
import UserInfoSection from "../UserInfoSection";
import { createStyles } from "./styles";







var UserAccountDropdown = function UserAccountDropdown(props) {
  var classes = createStyles({ customMainColor: props.customMainColor });

  // Concomitant layout
  var UserDropdownOption = function UserDropdownOption(_ref) {var href = _ref.href,linkText = _ref.linkText,icon = _ref.icon;
    return /*#__PURE__*/(
      React.createElement("li", { className: classes.userDropdownOption }, /*#__PURE__*/
      React.createElement("a", { href: href, className: classes.userDropdownLink }, /*#__PURE__*/
      React.createElement("span", { className: classes.userDropdownIcon }, icon), /*#__PURE__*/
      React.createElement("span", { className: classes.userDropdownLinkText }, linkText))));



  };

  // Common data
  var BasicUserDropdownOptions = [
  {
    value: HeaderLinksRoutes.CHANGE_AGENCY,
    renderFunc: function renderFunc(key) {return /*#__PURE__*/(
        React.createElement(UserDropdownOption, {
          key: key,
          href: HeaderLinksRoutes.CHANGE_AGENCY,
          icon: /*#__PURE__*/React.createElement(AssignmentInd, null),
          linkText: "Change Agency" }));}


  },
  {
    value: HeaderLinksRoutes.ACCOUNT_SETTINGS,
    renderFunc: function renderFunc(key) {return /*#__PURE__*/(
        React.createElement(UserDropdownOption, {
          key: key,
          href: HeaderLinksRoutes.ACCOUNT_SETTINGS,
          icon: /*#__PURE__*/React.createElement(AccountCircle, null),
          linkText: "Account Settings" }));}


  }];


  var LogoutDropdownOption = {
    value: HeaderLinksRoutes.LOGOUT,
    renderFunc: function renderFunc(key) {return /*#__PURE__*/(
        React.createElement(UserDropdownOption, {
          key: key,
          href: HeaderLinksRoutes.LOGOUT,
          icon: /*#__PURE__*/React.createElement(ExitToApp, null),
          linkText: "Logout" }));}


  };

  var ManageUsersDropdownOption = {
    value: HeaderLinksRoutes.USER_SERVICE,
    renderFunc: function renderFunc(key) {return /*#__PURE__*/(
        React.createElement(UserDropdownOption, {
          key: key,
          href: HeaderLinksRoutes.USER_SERVICE,
          icon: /*#__PURE__*/React.createElement(PeopleOutline, null),
          linkText: "Manage Users and Teams" }));}


  };

  var EmployeeDropdownOptions = [LogoutDropdownOption];

  // Component actions
  function createUserDropdownOptions() {var _context;
    var resultOptions = _concatInstanceProperty(_context = []).call(_context, BasicUserDropdownOptions);
    if (eeRights(props.currentUserRoles)) {
      return EmployeeDropdownOptions;
    }
    if (userAccessRights(props.currentUserRoles) || adminRights(props.currentUserRoles)) {
      resultOptions.push(ManageUsersDropdownOption);
    }
    resultOptions.push(LogoutDropdownOption);
    return resultOptions;
  }

  return /*#__PURE__*/(
    React.createElement(Dropdown, {
      name: "userInfo",
      options: createUserDropdownOptions(),
      openedElement: /*#__PURE__*/React.createElement(UserInfoSection, _extends({}, props, { classes: classes })),
      closedElement: /*#__PURE__*/React.createElement(UserInfoSection, _extends({}, props, { classes: classes })),
      className: classes.userAccountDropdown }));


};

export default UserAccountDropdown;
//# sourceMappingURL=index.js.map